/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBuyerOrders} from '../api'

 export const useQueryGetBuyerOrders = createReactQueryHook('getBuyerOrders', getBuyerOrders)
